import { createContext } from 'react';

type TTimelineNotesContext = {
  section: TimelineSection;
  sections: TimelineSection[];
};

type TEditingNotesContext = {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  notesText: string;
  setNotesText: (newValue: string) => void;
};

export const TimelineNotesContext = createContext<TTimelineNotesContext>(undefined!);

export const EditingNotesContext = createContext<TEditingNotesContext>(undefined!);
